<template>
<div>

  <Row style="margin-bottom: 10px;">
    <span style="font-size: 18px">Last 30 New Registered Clients</span>
    <Input @on-keydown="debounceInput" placeholder="Search..." style="width: 300px;float: right"/>
  </Row>

  <Table :columns="headers" :data="clientRequests" size="small" stripe @on-row-click="openCompanyDetail"
         max-height="700" class="client-approval-table">
    <template slot-scope="{ row }" slot="firstAddress">
      <span v-if="row.address[0].add1">{{row.address[0].add1}}, </span>
      <span v-if="row.address[0].add2">{{row.address[0].add2}}, </span>
      {{row.address[0].area}}, {{row.address[0].city}},<br>{{row.address[0].state}} - {{row.address[0].pincode}}
    </template>
    <template slot-scope="{ row }" slot="action">
      <Icon type="md-create" @click.stop="onEditCompany(row)" class="edit-icon" title="Edit Company"></Icon>
<!--      <Icon class="ivu-icon-md-checkmark-circle approve-option" title="Approve" @click.stop="approveClient(row.id)"></Icon>-->
<!--      <Icon class="ivu-icon-md-close-circle reject-option" title="Reject" @click.stop="rejectClient(row.id)"></Icon>-->
    </template>
  </Table>

  <company-detail ref="company-detail-page"></company-detail>
  <edit-company-drawer ref="edit-company-form"></edit-company-drawer>

</div>
</template>

<script>
import {SUBSCRIBE_CLIENT_REQUEST} from "../../graphql/subscription/companies";
import {UPDATE_CLIENT} from "../../graphql/mutations/companies";
import EditCompanyDrawer from "../EditCompanyDrawer";
import CompanyDetail from "../CompanyDetail";
import _ from 'lodash';

    export default {
        name: "ClientRegistration",
      components: {CompanyDetail, EditCompanyDrawer},
      apollo: {
          $subscribe: {
            company: {
              query: SUBSCRIBE_CLIENT_REQUEST,                        //Last 30 Approved Clients
              variables () {return {limit:30 /*searchFilter: '%' + this.searchFilter + '%',*/}},
              result ({ data }) {
                this.clientRequests = data.company;
              },
            }
          }
        },
        data: function(){
          return{
            clientRequests: [],
            tempClientRequests: null,
            searchFilter: '',
            headers: [
              { title: 'Name', key: 'name'},
              { title: 'Mobile', key: 'mobile', width:150},
              { title: 'Email', key: 'email' },
              { title: 'City', width:100, key:'city',
                render:(h, params) => {return h('div',params.row.address[0].city)}},
              { title: 'GSTIN', key: 'gstin' },
              { title: 'Address', slot: 'firstAddress' },
              { title: 'Action', slot: 'action', align:'center'},
            ],
            updateCompanyDrawer: false,       //when edit company
            companyDetailDrawer: false,
          }
        },
      methods:{
        debounceInput: _.debounce(function (e) {
          // this.searchFilter = e.target.value
          this.tempClientRequests = this.tempClientRequests || this.clientRequests;
          const needle = e.target.value.toLowerCase();
          this.clientRequests = this.tempClientRequests.filter(c => c.name.toLowerCase().indexOf(needle) > -1 ||
                                  c.mobile.indexOf(needle) > -1 || c.email.toLowerCase().indexOf(needle) > -1 ||
                                  c.gstin.toLowerCase().indexOf(needle) > -1);
        }, 500),
        openCompanyDetail (rowData, rowindex) {
          this.companyId = rowData.id
          this.$refs['company-detail-page'].skip = false
          this.companyDetailDrawer = true
        },
        onEditCompany (row) {
          this.$refs['edit-company-form'].companyType_skip = false;
          this.$refs['edit-company-form'].setCompanyForm(row);
          this.updateCompanyDrawer = true
        },
        approveClient(clientId){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to approve Client ?</p>',
            loading: true,
            onOk: () => {
              this.updateClient(clientId, {isApproved: true}, this.$Modal);
            }
          });
        },
        rejectClient(clientId){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to reject Client ?</p>',
            loading: true,
            onOk: () => {
              this.updateClient(clientId, {isRejected: true}, this.$Modal);
            }
          });
        },
        async updateClient(clientId, updateData, callback){
          let response = await this.$apollo.mutate({
            mutation: UPDATE_CLIENT,
            variables: {
              id: clientId,
              object: updateData
            }
          })
          callback.remove();
          if(response.data){
            this.$Message.success('Client updated successfully!');
          }
        }
      }
    }
</script>

<style scoped>
/deep/ .client-approval-table > .ivu-table > .ivu-table-body{
  font-size: 14px;
}
.edit-icon{
  /*float: right;*/
  cursor: pointer;
}
.approve-option{
  color: #87d068;
  font-size: 24px;
  cursor: pointer;
}
.reject-option{
  color: red;
  font-size: 24px;
  margin-left: 6px;
  cursor: pointer;
}
</style>
